import React from 'react';
import styles from './CustomDetails.module.scss';

export default function TitleSection({ children }) {
  return <h1 className={styles.title}>{children}</h1>;
}
